import { logger } from '@/monitoring'
import { useConfigStore } from '@/store/config'
import { pinia } from '@/store/pinia'

let audioContext: AudioContext | null = null

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new AudioContext()
  }
  return audioContext
}

function initAudio() {
  const ctx = getAudioContext()
  if (ctx.state === 'suspended') {
    ctx.resume()
  }
}

document.addEventListener('touchstart', initAudio, { once: true })
document.addEventListener('click', initAudio, { once: true })

export function playSound(name: 'payment' | 'cancel' | 'notification' | 'alert') {
  const config = useConfigStore(pinia)
  if (config.mute) return

  const ctx = getAudioContext()
  if (ctx.state === 'suspended') {
    ctx.resume()
  }

  const sound = new Audio(`${name}.mp3`)
  const source = ctx.createMediaElementSource(sound)
  source.connect(ctx.destination)
  sound.play().catch(error => {
    logger.warn('Error playing sound:', { error })
  })
}
